import * as React from "react";
import { Feature } from "ol";
import { useNomaContext } from "../Contexts/MapContext";

export interface IPopupRow {
    fieldName: string;
    feature: Feature;
    classname?: string;
}

export const PopupRow = ({ fieldName, feature, classname }: IPopupRow): JSX.Element => {
    const { getFieldAlias, getFieldValue } = useNomaContext();

    const alias = getFieldAlias(fieldName);
    const value = getFieldValue(feature, fieldName);
    const rowClassName = classname || "popup-row";

    return alias && value ? (
        <div className={rowClassName}>
            <span className={rowClassName + "-title"}>{alias + ": "}</span>
            <span className={rowClassName + "-value"}>{value}</span>
        </div>
    ) : null;
};
